function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.32 22.27l5.442-6.35-5.442-6.348a1 1 0 0 1 1.519-1.302l5.72 6.675a1.5 1.5 0 0 1 0 1.952l-5.72 6.675a1 1 0 0 1-1.519-1.302z"
});

var SvgRightarrowSmall = function SvgRightarrowSmall(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "07bb19f55d1cb78bf1b87edc8171730b.svg";
export { SvgRightarrowSmall as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/rightarrow-small.svg
// module id = null
// module chunks = 